import * as React from "react";
import {cx} from "emotion";

import "./pricing-table.scss";

import {cs}           from "@Common/react/chain-services";
import {keyed}        from "@Common/react/keyed";
import {UseState}     from "@Common/react/use-state";
import {Select}       from "@Common/ui-components/heavy/common/design2/select/select";
import {formatMoney1} from "@Common/ui-components/language/format-money";
import {sort}         from "@Common/utils/collections";
import {chain}        from "@Common/utils/fs";
import {entries}      from "@Common/utils/objects";

import {MultiColumnValueTable} from "./multi-column-value-table/multi-column-value-table";
import {formatNumberBig} from "@Common/ui-components/language/format-number-big";

export const PricingTable = ({templateOptions}) => cs(

    ["tabIndex", (_, next) => UseState({initValue: 0, next})],
    ["tabs", ({}, next) => next(tabs.filter((t) => t.isAvailable(templateOptions)))],
    ["activeTab", ({tabIndex, tabs}, next) => next(tabs[tabIndex.value])],
    ["paperType", (_, next) => UseState({next})],
    ["calPaperType", ({paperType, activeTab}, next) => next((() => {
        const paperTypes = activeTab.getPaperTypes(templateOptions);
        return paperType.value && paperTypes.includes(paperType.value) ? paperType.value : paperTypes[0];
    })())],
    ({activeTab, tabIndex, tabs, paperType, calPaperType}) => (
        <div className="pricing-table-45m">
            <div className="tabs">
                {tabs.map((step, i) => cs(
                    keyed(step.label),
                    () => (
                        <div {...{
                            className: cx("item", {active: activeTab === step}),
                            onClick: () => tabIndex.onChange(i),

                            "xd-qa-type": "button",
                            "xd-qa-name": step.label + " Tab",
                        }}>
                            {step.label}
                        </div>
                    )
                ))}
            </div>

            <div className="content">

                {cs(
                    ["paperTypes", (_, next) => next(activeTab.getPaperTypes(templateOptions))],
                    ({paperTypes}, next) => paperTypes.length !== 1 && next(),
                    ({paperTypes}) => (
                        <div className="paper-type">
                            <div className="label">
                                Paper Type
                            </div>
                            {Select({
                                list: paperTypes,
                                itemToLabel: (pt)=>pt.name,
                                isSelected: (pt)=>pt === calPaperType,
                                onChange: (pt)=>paperType.onChange(pt),
                                xdQaName: "Paper Type",
                            })}
                        </div>
                    ),
                )}

                {cs(
                    ["prices", (_, next) => next(activeTab.getPrices(calPaperType))],
                    ({prices}, next) => !prices ? (
                        <div className="error">
                            No pricing
                        </div>
                    ) : (
                        next()
                    ),
                    ({prices}) => MultiColumnValueTable({
                        header: {
                            labelHeader: "QTY",
                            valueHeader: "PRICE",
                        },
                        list: toPriceTableValues(prices),
                    }),
                )}
            </div>
        </div>
    ),
);

const getPaperTypes = (condition) => (to) => to.options.filter((o) => o.group === "PaperTypes" && condition(o));
const tabs = [
    {
        label: "First Class Mail",
        isAvailable: (to) => to.distributions?.includes("mailing") && to.mailingClasses.hasOwnProperty("1"),
        getPaperTypes: getPaperTypes((o) => o.distributionFilter.includes("mailing")),
        getPrices: (pt) => pt?.productPrice?.mailing?.["1"],
    },
    {
        label: "Standard Mail",
        isAvailable: (to) => to.distributions?.includes("mailing") && to.mailingClasses.hasOwnProperty("3"),
        getPaperTypes: getPaperTypes((o) => o.distributionFilter.includes("mailing")),
        getPrices: (pt) => pt?.productPrice?.mailing?.["3"],
    },
    {
        label: "Shipping",
        isAvailable: (to) => to.distributions?.includes("shipping"),
        getPaperTypes: getPaperTypes((o) => o.distributionFilter.includes("shipping")),
        getPrices: (pt) => pt?.productPrice?.shipping,
    },
];

const toPriceTableValues = (prices) => chain(
    prices,
    (_) => entries(_),
    (_) => sort(_, ([_, qty]) => qty.min ?? 0),
    (_) => _.map(([key, qty]) => ({
        value: formatMoney1(+(qty.price ?? key)),
        label: (
            qty.min == null ? (
                formatNumberBig(qty.max) + " and below"
            ) : qty.max == null ? (
                formatNumberBig(qty.min) + " and above"
            ) : (
                formatNumberBig(qty.min) + "-" + formatNumberBig(qty.max)
            )
        )
    })),
);


// const prices = {
//     "0.60" : {"min": 20000},
//     "0.55": {"min": 10000, max: 20000},
//     "0.65": {"min": 5000, "max":9999},
//     // "0.66": {"min": 5000, "max":9999},
//     // "0.67": {"min": 5000, "max":9999},
//     "0.70": {"min": 1000, "max":4999},
//     "0.75": {"min": 500, "max":999},
//     "1.10": {"min": 200, "max":499},
//     "0.85": {"min": 25, "max":99}
// };
